<template>
    <div class="section">
        <div class="project one">
            <div class="image-box">
                <img src="../assets/images/screenshots/cash-register.png" alt="" class="image">
            </div>
            <div class="details">

                <div class="title">Cash Register Application</div>
                <div class="description">A Cash Register Web Application that calculates the total for goods sold and customer change. The application is built mainly in Vue.js and pulls data from a public API serving store items.</div>
                <div class="buttons">
                    <a href="https://helix-cashier-application.netlify.app/" target="_blank" class="link-btn live">Preview</a>
                    <!-- <a href="https://github.com/Helixmw/cashregisterapp" target="_blank" class="link-btn code">Code</a> -->
                </div>
            </div>
        </div>
        <div class="project two">
            <div class="image-box">
                <img src="../assets/images/screenshots/inventory-web-app.png" alt="" class="image">
            </div>
            <div class="details">

                <div class="title">Inventory Application</div>
                <div class="description">An Inventory Application Portal with a dashboard data table that allows you to add and delete inventory items. Built in Vue.js, Laravel web API and with a PostgreSQL Database. Authentication is required.</div>
                <div class="buttons">
                    <a href="https://helixinventoryapp.netlify.app" target="_blank" class="link-btn live">Preview</a>
                    <a href="https://github.com/Helixmw/Inventory-Records-API" target="_blank" class="link-btn code">Code</a>
                </div>
            </div>
        </div>
        <div class="project three">
            <div class="image-box">
                <img src="../assets/images/screenshots/inventory-desktop-app.png" alt="" class="image">
            </div>
            <div class="details">

                <div class="title">Desktop Inventory Application</div>
                <div class="description">A Desktop Inventory Application allows you to add and delete inventory items. Built as a WinForms project with a SQLite database and uses Dapper micro-ORM Library. Installation file (.exe) is required.</div>
                <div class="buttons">
                    <a target="_blank" class="link-btn live disabled">Preview</a>
                   <a href="https://github.com/Helixmw/Inventory-Desktop-Application" target="_blank" class="link-btn code">Code</a>
                </div>
            </div>
        </div>
        <div class="project four">
            <div class="image-box">
                <img src="../assets/images/code.jpg" alt="" class="image">
            </div>
            <div class="details">

                <div class="title">Business Employees Web API</div>
                <div class="description">An ASP.NET Web API project of an Employees API developed with Entity Framework Core and a Microsoft SQL Server Database. This project is for source code demonstration.</div>
                <div class="buttons">
                    <a target="_blank" class="link-btn live disabled">Preview</a>
                    <a href="https://github.com/Helixmw/Business-Employees-API" target="_blank" class="link-btn code">Code</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SampleProject from './SampleProject.vue';
export default{
    components:{
        SampleProject
    },
    data(){
        return{
            projects:[
                {
                    image:"../assets/images/screenshots/cash-register.png",
                    name:"Cash Register",
                    description:"A Cash Register Web Application that calculates the total for goods sold and customer change. The application is built mainly in Vue.js and pulls data from a hosted public web API storing shopping goods.",
                    live:"https://helixmw.github.io/cashregisterapp/",
                    code:"https://github.com/Helixmw/cashregisterapp"                    
                },
                {
                    image:"../assets/images/screenshots/inventory-web-app.png",
                    name:"Inventory Application",
                    description:"An Inventory Application Portal with a dashboard data table allowing you to add and delete inventory items. Built in Vue.js, Laravel web API and with a PostgreSQL Database. Authentication is required.",
                    live:"https://helixinventoryapp.netlify.app/login",
                    code:"https://github.com/Helixmw/Inventory-Records-API"                    
                },
                {
                    image:"../assets/images/screenshots/inventory-desktop-app.png",
                    name:"Desktop Inventory Application",
                    description:"A Desktop Inventory Application allowing you to add and delete inventory items built in WinForms with a SQLite database and uses Dapper micro-ORM Library. Installation file (.exe) is required.",
                    live:"",
                    code:"https://github.com/Helixmw/Inventory-Desktop-Application"                    
                },
                {
                    image:"",
                    name:"Business Employees Web API",
                    description:"An ASP.NET Web API project of an Business Employees API developed with Entity Framework Core and a Microsoft SQL Server Database. This project is for source code demonstration only; demonstrating design pattern in coding practice.",
                    live:"",
                    code:"https://github.com/Helixmw/Business-Employees-API"                    
                },
                
            ]
        }
    }

}
</script>
<style scoped>

.image-box{
    height:10rem;
    display:flex;
    justify-content: center;
    border-radius:4px;
    /* background-color: rgba(0,0,0,0.5); */
}

.title{
    font-family: var(--text-b);
    font-size: var(--md);
    color:var(--blue);
    margin-bottom:0.5rem;
}

.description{
    margin-bottom:1rem;
}



.details{
    padding:0.8rem;
}

.image{
    object-fit:cover;
    height:100%;
    width:100%;
    border:1px solid var(--light);
    border-top-left-radius: var(--radius);
    border-top-right-radius: var(--radius);
}

.disabled{
    background-color: var(--gold3)!important;
}

.project{
    background-color:var(--light);
    border-radius:var(--radius);
   
    /* min-height: 10rem; */
}

.buttons{
 
    bottom:0;
}

.link-btn{
    text-decoration: none;
    padding:0.5rem 0.8rem;
    color:white;
    border-radius:var(--radius);
    cursor: pointer;
}

.live{
    background-color: var(--gold);
}

.code{
    background-color:var(--blue) ;
    margin-left:0.4rem;
}


.three .four .buttons{
    margin-top: 2.5rem;
}


.section{
    padding:2rem;
    display: grid;
    column-gap:1rem;
    row-gap: 1rem;
    grid-template-columns: repeat(2, 1fr);

}

@media(max-width: 768px){
    .section{
        padding:1rem;
        grid-template-columns:1fr;
      
    }
}
</style>
